import React from 'react'
import { Button } from '@mui/material'
import theme from 'theme'
import { useTranslation } from 'react-i18next'

interface CategoryButtonProps {
  category: string
  isSelected: boolean
  onClick: (category: string) => void
}

const buttonStyles = {
  minWidth: '150px',
  border: 'none',
  textTransform: 'capitalize',
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16.94px',
  textAlign: 'left',
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    fontWeight: 600
  },
  '&.selected': {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    fontWeight: 600
  }
}

const CategoryButton: React.FC<CategoryButtonProps> = ({
  category,
  isSelected,
  onClick
}) => {
  const { t } = useTranslation()

  const getCategoryLabel = (cat: string) => {
    const categoryMap: { [key: string]: string } = {
      Cabinets: t('categories.cabinets'),
      Hardware: t('categories.hardware'),
      Richelieu: t('categories.richelieu')
    }
    return categoryMap[cat] || cat
  }

  return (
    <Button
      onClick={() => onClick(category)}
      sx={{
        ...buttonStyles,
        ...(isSelected && buttonStyles['&.selected'])
      }}
    >
      {getCategoryLabel(category)}
    </Button>
  )
}

export default CategoryButton
